import { useState } from 'react';

import { Delete, FactCheck, History } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';

type SheetsCollectorProps = {
  onSubmit: (tableData: string) => void;
  isLoading?: boolean;
  onOpenHistoryDialog: () => void;
};

export function SheetsCollector({
  onSubmit,
  isLoading = false,
  onOpenHistoryDialog,
}: SheetsCollectorProps) {
  const [tableData, setTableData] = useState<string>('');

  const handleSubmit = () => {
    onSubmit(tableData);
  };

  const handleClearTable = () => {
    setTableData('');
  };

  return (
    <Box
      sx={{
        my: 4,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 2,
        }}>
        <Typography variant="body1" sx={{ mb: 0 }}>
          Cole os valores da tabela do excel abaixo.
        </Typography>

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            startIcon={<History />}
            variant="text"
            color="secondary"
            onClick={onOpenHistoryDialog}
            sx={{ ml: 1 }}>
            Histórico
          </Button>
        </Box>
      </Box>

      <FormControl sx={{ width: '100%', gap: 2 }}>
        <TextField
          value={tableData}
          onChange={(e) => setTableData(e.target.value)}
          multiline
          fullWidth
          rows={10}
          placeholder="Setor	Ticker	Nome	Bid	Offer	Curva	Index	Vencimento
AUTOMOTIVO	5905724UN1	FIDC OMNI (POLIGONO) SENIOR	5,5	4	5	CDI+	12/99
..."
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              gap: 2,
              justifyContent: 'flex-end',
              flexWrap: 'wrap',
            }}>
            <Button
              startIcon={<Delete />}
              variant="text"
              color="secondary"
              onClick={handleClearTable}
              disabled={!tableData}>
              Limpar
            </Button>
            <Button
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} color="primary" />
                ) : (
                  <FactCheck />
                )
              }
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={!tableData || isLoading}>
              {isLoading ? 'Processando...' : 'Gerar URLs'}
            </Button>
          </Box>
        </Box>
      </FormControl>
    </Box>
  );
}
